import { useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import {
  useMediaQuery,
  ImageList,
  ImageListItem,
  Box,
  ListItemAvatar,
  Avatar,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { CircularProgressWithLabel } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const useStyles = makeStyles(theme => ({
  image: {
    borderRadius: theme.spacing(1),
  },
  textWhite: {
    color: 'white',
    textShadow: `1px 1px 2px ${theme.palette.action.active}`,
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: theme.spacing(2),
    backgroundColor: 'white',
    boxShadow: `0 2px 10px 0 ${theme.palette.cardShadow}`,
  },
  gridListTile: {
    position: 'relative',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.branding.yellow.light,
  },
  gridListSection: {
    position: 'absolute',
    bottom: theme.spacing(0),
    padding: theme.spacing(2),
  },
}));

export default function Featured({ className, institutions = [], ...rest }) {
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [loaded, setLoaded] = useState({});

  const pattern = [1, 3, 3, 1];

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="Explore nossas lojas em destaque"
        subtitle="Compre produtos e serviços educacionais em um único lugar."
      />
      {institutions.length > 0 && (
        <ImageList rowHeight={isMd ? 360 : 260} cols={4} spacing={isMd ? 24 : 8}>
          {institutions.map((institution, index) => (
            <Link href={`/e/${institution.slug}`} key={institution.slug} passHref>
              <ImageListItem
                component="a"
                cols={isMd ? pattern[index] : 4 || 1}
                className={classes.gridListTile}>
                {institution.cover && !loaded[institution.slug] && (
                  <Box display="flex" height="100%" alignItems="center" justifyContent="center">
                    <CircularProgressWithLabel size={90} />
                  </Box>
                )}
                {institution.cover && (
                  <Image
                    src={institution.cover}
                    alt={institution.displayName}
                    className={classes.image}
                    layout="fill"
                    objectFit="cover"
                    quality={50}
                    onLoad={event =>
                      setLoaded(prevState => ({
                        ...prevState,
                        [institution.slug]: event.target.complete,
                      }))
                    }
                  />
                )}
                <ListItemAvatar>
                  <Avatar
                    src={institution.logo}
                    alt={institution.displayName}
                    className={classes.avatar}
                  />
                </ListItemAvatar>
                <SectionHeader
                  title={<span className={classes.textWhite}>{institution.displayName}</span>}
                  disableGutter
                  className={classes.gridListSection}
                  align="left"
                />
              </ImageListItem>
            </Link>
          ))}
        </ImageList>
      )}
    </div>
  );
}

Featured.propTypes = {
  className: PropTypes.string,
  institutions: PropTypes.array,
};
